const compactName = (value: string) => value.toLowerCase().replace(/[^\p{L}\p{N}]/gu, '')

export const filterInstitutionsByName = <T extends { name: string }>(
  institutions: T[] | undefined,
  search: string
): T[] | undefined => {
  const query = compactName(search)
  if (!institutions || !query) {
    return institutions
  }

  return institutions.filter(institution => compactName(institution.name).includes(query))
}

export const hasNoInstitutionMatches = (
  institutions: { name: string }[] | undefined,
  search: string,
  isLoading: boolean
): boolean => {
  if (isLoading || institutions == null || search.trim().length === 0) {
    return false
  }

  return (filterInstitutionsByName(institutions, search)?.length ?? 0) === 0
}
